"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSfdcCampaigns = getSfdcCampaigns;
exports.getSfdcCampaignsRequestState = getSfdcCampaignsRequestState;
exports.getSfdcSyncEnabled = getSfdcSyncEnabled;
exports.getSfdcSettingsRequestState = getSfdcSettingsRequestState;

function getSfdcCampaigns(state) {
  return state.salesforceCampaigns.campaigns;
}

function getSfdcCampaignsRequestState(state) {
  return state.salesforceCampaigns.requestState;
}

function getSfdcSyncEnabled(state) {
  return state.salesforceCampaigns.sfdcSyncEnabled;
}

function getSfdcSettingsRequestState(state) {
  return state.salesforceCampaigns.requestStateSettings;
}